import { keepPreviousData, useQueries, useQuery } from '@tanstack/react-query';
import { autocompleteLocales, getLocale } from './api';

export const localeKeys = {
  all: ['locales'] as const,
  autocomplete: (q: string) => [...localeKeys.all, 'autocomplete', q] as const,
  detail: (id: string) => [...localeKeys.all, 'detail', id] as const,
};

/** Suggestions for the picker. Silent: a failed lookup shows "no matches", not a modal. */
export function useLocaleAutocomplete(q: string) {
  const term = q.trim();
  return useQuery({
    queryKey: localeKeys.autocomplete(term),
    queryFn: ({ signal }) => autocompleteLocales(term, 10, signal),
    enabled: term.length > 0,
    staleTime: 5 * 60_000,
    placeholderData: keepPreviousData,
    meta: { silent: true },
  });
}

/** Names for selected ids (e.g. restored from the URL). Locales change rarely. */
export function useLocalesById(ids: string[]) {
  return useQueries({
    queries: ids.map((id) => ({
      queryKey: localeKeys.detail(id),
      queryFn: () => getLocale(id),
      staleTime: 30 * 60_000,
      meta: { silent: true },
    })),
  });
}
